import { Component, Input } from '@angular/core';

type TNotePanel = 'appointment' | 'private';

/**
 * Two kinds of note live side by side here: what was said in a meeting, which the student can read
 * too, and the coach's own notes about the student, which nobody else sees. Meeting notes lead,
 * because that is what a coach writes right after a call.
 */
@Component({
  selector: 'coach-meeting-notes-tab',
  templateUrl: './meeting-notes-tab.component.html',
  styleUrl: './meeting-notes-tab.component.scss',
})
export class MeetingNotesTabComponent {
  @Input() studentId!: number;

  panel: TNotePanel = 'appointment';

  setPanel(panel: TNotePanel) {
    this.panel = panel;
  }
}
